import { observable, action } from 'mobx';
import { merge } from 'lodash';

export default class AppStore {
    @observable mediaWidth = 1440;

    constructor(state) {
        merge(this, state);
    }

    @action
    setMediaWidth(width) {
        this.mediaWidth = width;
    }
}



// WEBPACK FOOTER //
// ./src/common/stores/AppStore.js